import { render, staticRenderFns } from "./NeoCore.vue?vue&type=template&id=fe5cb4d8"
import script from "./NeoCore.vue?vue&type=script&lang=js"
export * from "./NeoCore.vue?vue&type=script&lang=js"
import style0 from "./NeoCore.vue?vue&type=style&index=0&id=fe5cb4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports